var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5043 20.6272C40.5043 31.605 31.605 40.5043 20.6272 40.5043C9.64931 40.5043 0.75 31.605 0.75 20.6272C0.75 9.64931 9.64931 0.75 20.6272 0.75C31.605 0.75 40.5043 9.64931 40.5043 20.6272Z",
    fill: "#6481E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8603 6.64128V26.7068L29.7764 21.4359L20.8603 6.64128Z",
    fill: "#C1CCF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9434 21.4359L20.8603 26.7068V6.64128L11.9434 21.4359Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8602 17.3834L11.9434 21.4359L20.8603 26.7068L29.7764 21.4359L20.8602 17.3834Z",
    fill: "#8299EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8603 28.3949V35.6925L29.7823 23.1269L20.8603 28.3949Z",
    fill: "#C1CCF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8602 17.3834L11.9434 21.4359L20.8603 26.7068L20.8602 17.3834Z",
    fill: "#C1CCF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9435 23.1269L20.8596 35.6919L20.8603 28.3949L11.9435 23.1269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.f0c9976648c69641fac520d5af74f9f0.svg";
export { ForwardRef as ReactComponent };